import { PaymentMethodType } from "./constans";

const UTILS = {
    getPrimaryColor() {
        return this.isSahlDomain() ? '#4055FF' : '#4055FF'
    },
    isSahlDomain() {
        return window.location.href.includes('sahl');
    },
    isExpiryValid(expiry) {
        if (expiry?.length !== 5) return false;
    
        const month = parseInt(expiry.substring(0, 2));
        const year = parseInt(expiry.substring(3, 5));
    
        if (month < 1 || month > 12) return false;
    
        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const currentYear = now.getFullYear() % 100;
    
        if (year < currentYear) return false;
        if (year === currentYear && month < currentMonth) return false;
    
        return true;
    },
    ValidateFormData(data, paymentMethod) {
        if (paymentMethod === PaymentMethodType.BankCard) {
            return (
                data.payment_number?.length === 19 &&
                this.isExpiryValid(data.expiry_date) &&
                data.cvv?.length === 3 &&
                data.first_name?.length > 0 &&
                data.last_name?.length > 0
            );
        }
        
        if (paymentMethod === PaymentMethodType.Wallet) {
            return data.payment_number?.length > 0;
        }
        return false;
    },
}

export default UTILS;
